import styled from 'styled-components'

const HeaderElement = styled.div`
  padding-left: 15px;
`

export default HeaderElement
